<template>
  <div>
    <div class="white-section">
      <div class="d-flex mb-1 align-items-center">
        <div class="page-title users-page-title">
          <b-breadcrumb-item
            v-for="item in breadcrumb"
            :key="item.text"
            :active="item.active"
            class="bread-crumb"
          >
            <div v-if="item.active">
              {{ item.translate ? $t(`navigation.${item.text}`) : item.text }}
            </div>
          </b-breadcrumb-item>
        </div>
        <b-card-body
          style="padding: 0"
          class="search-box d-flex justify-content-end"
        >
          <!-- search input -->
          <b-col xl="4" lg="6" cols="12" sm="6" class="mb-md-0">
            <b-form-input
              @input="searchUser"
              v-model="searchTerm"
              :placeholder="$t('general.search')"
              type="text"
              class="d-inline-block"
            />
          </b-col>
        </b-card-body>
        <!-- <router-link
          :disabled="
            !$ability.can('create', 'users') &&
            !$ability.can('read', 'superuser')
          "
          tag="button"
          :to="{ name: 'addUser' }"
          class="btn btn-success btn-add"
          >{{ $t("general.add") }}
        </router-link> -->
      </div>

      <Plan
        :doctorIdSelected="doctorIdSelected"
        :doctorName="doctorName"
        @close="close"
        v-if="modalShow"
      />

      <!-- table -->
      <div class="users-table user-table" v-if="!isLoading && users.length != 0">
        <vue-good-table
          v-if="users"
          :columns="columns"
          :rows="users"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
            mode: 'pages',
          }"
        >
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.label === 'action'" class="text-nowrap">
              {{ $t("general.action") }}
            </span>
            <span v-else>
              {{ $t(`user.${props.column.label}`) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->
            <span v-if="props.column.field === 'name'" class="text-nowrap">
              <span>{{ props.row.firstName }} {{ props.row.lastName }}</span>
            </span>

            <!-- Column: Action -->
            <span v-if="props.column.field === 'action'">
              <span>
                <button
                  class="btn btn-primary btn-sm mr-1"
                  @click="
                    $bvModal.show('modal-scoped');
                    getDoctorIdselected(props.row);
                  "
                >
                  {{ $t("general.planOfDoctor") }}
                </button>
              </span>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t("pagination.pageLength") }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['20', '50', '100']"
                  class="mx-1"
                  @change="handlePageChange"
                />
                <span class="text-nowrap">
                  {{ $t("general.of") }} {{ total }}
                  {{ $t("general.pageText2") }}
                </span>
              </div>
              <div>
                <b-pagination
                  v-model="page"
                  :total-rows="total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @change="handlePageChange"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BButton,
} from "bootstrap-vue";
import Vue from "vue";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";
import filterRoles from "@/mixins/filterRoles";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
import dateFormat from "@/mixins/dateFormat";
import flatPickr from "vue-flatpickr-component";
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import Plan from "@/components/modal/CreateDoctorPlan.vue";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,
  BFormCheckbox,
  BCard,
  BCardHeader,
  BCardBody,
  BFormSelectOption,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormSelectOption,
    BButton,
    MyAbDatePicker,
    flatPickr,
    Multiselect,
    required,
    requiredIf,
    minLength,
    maxLength,
    sameAs,
    MyVSelect,
    Plan,
  },
  mixins: [dateFormat],
  data() {
    return {
      pageLength: 100,
      startDate: "",
      endDate: "",
      duration: 10,
      searchTime: ["00:00", "00:05"],
      page: 1,
      dir: false,
      selectDays: [],
      countOfQueue: 1,
      searchedUnits: "",
      days: [
        { key: 0, name: "شنبه ها", enName: "Saturdays" },
        { key: 1, name: "یکشنبه ها", enName: "Sundays" },
        { key: 2, name: "دوشنبه ها", enName: "Mondays" },
        { key: 3, name: "سه شنبه ها", enName: "Tuesdays" },
        { key: 4, name: "چهارشنبه ها", enName: "Wednesdays" },
        { key: 5, name: "پنجشنبه ها", enName: "Thursdays" },
        { key: 6, name: "جمعه ها", enName: "Fridays" },
      ],
      doctorId: "",
      doctorIdSelected: "",
      doctorName: "",
      modalShow: false,
      isLoading:false,
      columns: [
        {
          label: "name",
          field: "name",
        },
        {
          label: "username",
          field: "username",
        },
        {
          label: "nationalCode",
          field: "nationalCode",
        },
        {
          label: "mobile",
          field: "mobile",
        },
        {
          label: "action",
          field: "action",
        },
      ],
      rows: [],
      searchTerm: "",
    };
  },
  validations() {
    return {
      startDate: {
        required,
      },
      endDate: {
        required,
      },
      duration: {
        required,
      },
      selectDays: {
        required,
      },
      countOfQueue: {
        required,
      },
      searchedUnits: {
        required,
      },
    };
  },
  methods: {
    getDoctorIdselected(item) {
      this.doctorIdSelected = item._id;
      this.doctorName = item.firstName + " " + item.lastName;
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
    },
    checkIfUserIsPatient(user) {
      if (
        user.roles.find((userToEditRole) => {
          return userToEditRole === this.filterRoles("patient");
        })
      ) {
        return true;
      } else {
        return false;
      }
    },
    medicalRecord(user, type = "infertility") {
      switch (type) {
        case "infertility":
        case "obstetric":
          if (user.gender) {
            if (user.spouses && user.spouses.length) {
              let femaleId = "";
              let maleId = "";
              let relationshipId = user.spouses[0].relationshipId;
              if (user.gender === "female") {
                femaleId = user._id;
                maleId = user.spouses[0].spouseId;
              } else {
                femaleId = user.spouses[0].spouseId;
                maleId = user._id;
              }
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                },
              });
            } else
              this.$bvToast.toast(
                this.$t("toastification.spouseNotRegistered"),
                {
                  title: this.$t("toastification.warning"),
                  variant: "warning",
                  solid: true,
                }
              );
          } else
            this.$bvToast.toast(this.$t("toastification.genderNotDetect"), {
              title: this.$t("toastification.warning"),
              variant: "warning",
              solid: true,
            });
          break;
        case "genetics":
        case "legal":
        case "nourish":
        case "glands":
          if (user.gender) {
            if (user.spouses && user.spouses.length) {
              let femaleId = "";
              let maleId = "";
              let relationshipId = user.spouses[0].relationshipId;
              if (user.gender === "female") {
                femaleId = user._id;
                maleId = user.spouses[0].spouseId;
              } else {
                femaleId = user.spouses[0].spouseId;
                maleId = user._id;
              }
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                  gender: user.gender,
                },
              });
            } else {
              let femaleId = 0;
              let maleId = 0;
              let relationshipId = 0;
              if (user.gender === "female") {
                femaleId = user._id;
              } else {
                maleId = user._id;
              }
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                  gender: user.gender,
                },
              });
            }
          } else
            this.$bvToast.toast(this.$t("toastification.genderNotDetect"), {
              title: this.$t("toastification.warning"),
              variant: "warning",
              solid: true,
            });
          break;
        case "urology":
        case "gynecology":
          if (user.gender) {
            if (user.spouses && user.spouses.length) {
              let femaleId = "";
              let maleId = "";
              let relationshipId = user.spouses[0].relationshipId;
              if (user.gender === "female") {
                femaleId = user._id;
                maleId = user.spouses[0].spouseId;
              } else {
                femaleId = user.spouses[0].spouseId;
                maleId = user._id;
              }
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                },
              });
            } else {
              let femaleId = 0;
              let maleId = 0;
              let relationshipId = 0;
              if (user.gender === "female") {
                femaleId = user._id;
              } else {
                maleId = user._id;
              }
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                },
              });
            }
          } else
            this.$bvToast.toast(this.$t("toastification.genderNotDetect"), {
              title: this.$t("toastification.warning"),
              variant: "warning",
              solid: true,
            });
          break;
        default:
          this.$bvToast.toast(this.$t("toastification.medicalRecordNotFound"), {
            title: this.$t("toastification.warning"),
            variant: "warning",
            solid: true,
          });
          break;
      }
    },

    // searchUser() {
    //   let payload = {};
    //   if (this.roleFilter.length) {
    //     payload.roles = [];
    //     payload.roles[0] = this.roleFilter;
    //   }
    //   payload.page = 1;
    //   payload.limit = 20;
    //   this.$store.dispatch("user/searchUsers", payload).then((res) => {
    //     this.$store.commit("user/SET_USERS", res);
    //   });
    // },

    searchUser() {
      this.isLoading = true
      if (this.searchTerm.length || this.roleFilter.length) {
        let payload = {};
        this.searchTerm.length ? (payload.keyword = this.searchTerm) : "";
        if (this.roleFilter.length) {
          payload.roles = [this.roleFilter];
        }
        payload.page = parseInt(this.page);
        payload.limit = parseInt(this.pageLength);
        this.$store.commit("SET_IS_LOADING", true);
        this.$store.dispatch("user/searchUsers", payload).then((res) => {
          this.pageLength = payload.limit
          this.$store.commit("SET_IS_LOADING", false);
          this.$store.commit("user/SET_USERS", res);
          this.isLoading = false
        });
      } else {
        this.$store.dispatch("user/getUsers", {
          page: parseInt(this.page),
          limit: parseInt(this.pageLength),
        });
      }
    },

    switchStatus(val, props) {
      val === true ? (props.status = "active") : (props.status = "inactive");
      let payload = {
        status: props.status,
      };
      this.$store
        .dispatch("user/switchUserStatus", {
          id: props._id,
          payload: payload,
        })
        .then(() => {
          this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
            // title: this.$t('toastification.success'),
            variant: "success",
            solid: true,
          });
        })
        .catch((error) => {
          this.$bvToast.toast(this.$t("toastification.submissionFailed"), {
            variant: "danger",
            solid: true,
          });
        });
    },
    changePassword(user) {
      this.$store.commit("user/SET_USER_TO_EDIT", user);
      this.$router.push({
        name: "changeOtherUsersPassword",
        params: {
          id: user._id,
        },
      });
    },
    editUser(user) {
      this.$store.commit("user/SET_USER_TO_EDIT", user);
      if (user.addresses && user.addresses.length) {
        user.addresses.forEach((address, index) => {
          !this.addresses[index] ? (this.addresses[index] = {}) : "";
          address.address
            ? (this.addresses[index].address = address.address)
            : "";
          address.cityId ? (this.addresses[index].cityId = address.cityId) : "";
          address.countryId
            ? (this.addresses[index].countryId = address.countryId)
            : "";
          address.type ? (this.addresses[index].type = address.type) : "";
        });
      }
      if (user.phones && user.phones.length) {
        user.phones.forEach((phone, index) => {
          this.phones[index].countryId = phone.countryId;
          this.phones[index].phone = phone.phone;
          this.phones[index].internal = phone.internal;
          this.phones[index].type = phone.type;
        });
      }
      if (user.mobiles && user.mobiles.length) {
        user.mobiles.forEach((mobile, index) => {
          this.mobiles[index].countryId = mobile.countryId;
          this.mobiles[index].mobile = mobile.mobile;
        });
      }
      if (
        this.userToEdit.roles.find((userToEditRole) => {
          return userToEditRole === this.filterRoles("patient");
        })
      ) {
        this.$router.push({ name: "editPatient", params: { id: user._id } });
      } else {
        this.$router.push({ name: "editUser", params: { id: user._id } });
      }
    },
    handlePageChange() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  computed: {
    breadcrumb() {
      return typeof this.$route.meta.breadCrumb === "function"
        ? this.$route.meta.breadCrumb(this.$route)
        : this.$route.meta.breadCrumb;
    },
    ...mapGetters({
      isRtl: "appConfig/isRTL",
      roles: "roles",
      userToEdit: "user/userToEdit",
      units: "units/units",
    }),
    total: {
      get() {
        return this.$store.getters["user/total"];
      },
    },
    addresses: {
      set(addresses) {
        this.$store.commit("user/SET_ADDRESSES", addresses);
      },
      get() {
        return this.$store.getters["user/addresses"];
      },
    },
    phones: {
      set(phones) {
        this.$store.commit("user/SET_PHONES", phones);
      },
      get() {
        return this.$store.getters["user/phones"];
      },
    },
    roleFilter: {
      set(role) {
        this.$store.commit("user/SET_ROLE_FILTER", role);
      },
      get() {
        return this.$store.getters["user/roleFilter"];
      },
    },
    mobiles: {
      set(mobiles) {
        this.$store.commit("user/SET_MOBILES", mobiles);
      },
      get() {
        return this.$store.getters["user/mobiles"];
      },
    },
    statusVariant() {
      const statusColor = {
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
      };
      return (status) => statusColor[status];
    },

    users: {
      set(users) {
        this.$store.commit("user/SET_USERS", users);
      },
      get() {
        return this.$store.getters["user/users"];
      },
    },

    invalidFeedbackStartDate: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.startDate.$dirty) return error;
        if (!this.$v.startDate.required) error = "required";
        return error;
      },
    },
    invalidFeedbackEndDate: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.endDate.$dirty) return error;
        if (!this.$v.endDate.required) error = "required";
        return error;
      },
    },
    invalidFeedbackDuration: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.duration.$dirty) return error;
        if (!this.$v.duration.required) error = "required";
        return error;
      },
    },
    invalidFeedbackSelectDays: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.selectDays.$dirty) return error;
        if (!this.$v.selectDays.required) error = "required";
        return error;
      },
    },
    invalidFeedbackCountOfQueue: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.countOfQueue.$dirty) return error;
        if (!this.$v.countOfQueue.required) error = "required";
        return error;
      },
    },
    invalidFeedbackUnitofPlan: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.searchedUnits.$dirty) return error;
        if (!this.$v.searchedUnits.required) error = "required";
        return error;
      },
    },
  },
  watch: {
    page() {
      this.searchUser();
    },
    pageLength() {
      this.page=1
      this.searchUser();
    },
  },
  directives: {
    Ripple,
  },
  mixins: [filterRoles],
  created() {
    this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "doctorsList", to: { name: "manageDoctors" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "doctorsList", to: { name: "doctorsList" }, translate: true },
    ]);
    this.$store.dispatch("getRoles").then((res) => {
      this.roleFilter = this.roles.find((r) => {
        return r.title == "doctor";
      })._id;
      this.searchUser();
      this.doctorId = this.filterRoles("doctor");
      if (!this.roleFilter) this.roleFilter = this.doctorId;
      this.searchUser();
    });
    this.$store.dispatch("units/searchUnit", {
      status:"active"
    });
  },
};
</script>

<style scoped>
.time-picker .flatpickr-input {
  height: 32px;
}
</style>
